// extracted by mini-css-extract-plugin
export var childrenContainer = "_19-0";
export var virtualScrollArea = "_19-1";